<script lang="ts">
  // Carte des États brésiliens (contours simplifiés de click_that_hood, projetés d'avance dans lib/estados.json) :
  // aplat de 6 teintes malbec selon la valeur importée (échelle racine carrée), infobulle native — même rendu que
  // la carte des régions de /francia/.
  import GEO from '../lib/estados.json';
  import { usd, pct } from '../lib/format';
  import { t, tf } from '../lib/i18n.svelte';

  type Feat = { n: string; s: string; d: string; c: number[] };
  let { rows, year }: { rows: { n: string; v: number; sh: number }[]; year: string } = $props();

  const norm = (s: string) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z]/g, '');
  const SHADES = ['#F1E3E2', '#E2C0BE', '#CF9693', '#B95955', '#8A3B42', '#58212D'];
  const G = GEO as unknown as { w: number; h: number; f: Feat[] };

  const byName = $derived(new Map(rows.map((r) => [norm(r.n), r])));
  const vmax = $derived(Math.max(1, ...rows.map((r) => r.v)));
  const col = (v: number | undefined) => (v == null || v <= 0 ? '#E8E4E2' : SHADES[Math.min(5, Math.floor(Math.sqrt(Math.max(0, v) / vmax) * 5.999))]);
</script>

<svg viewBox="0 0 {G.w} {G.h}" width="100%" class="fr-map" role="img">
  {#each G.f as f (f.n)}
    {@const r = byName.get(norm(f.n))}
    <path d={f.d} fill={col(r?.v)}><title>{f.n} : {r ? usd(r.v) + ' (' + pct(r.sh) + ')' : '—'}</title></path>
  {/each}
  {#each G.f as f (f.n)}
    <text class="br-sg" x={f.c[0]} y={f.c[1] + 3} text-anchor="middle">{f.s}</text>
  {/each}
</svg>
<div class="fr-maplegend">
  {tf('map.legend', { y: year })}
  <span>{t('map.low')}</span>
  {#each SHADES as s (s)}<i style="background:{s}"></i>{/each}
  <span>{t('map.high')}</span>
</div>
